import * as api from '../api'

//Action Creators
export const getProperties = () => async (dispatch) => {
  try {
    const { data } = await api.fetchProperties()
    dispatch({ type: 'FETCH_PROPERTIES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
